import { render, staticRenderFns } from "./CultureTableView.vue?vue&type=template&id=54baf280&scoped=true&"
import script from "./CultureTableView.vue?vue&type=script&lang=js&"
export * from "./CultureTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baf280",
  null
  
)

export default component.exports